// context.tsx
import React, { createContext, useContext, useMemo, useRef, useState } from 'react';

//helepers
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';

// Create the context
const VideoContext = createContext<any>(null);

// Define the context provider
export const VideoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const videoRef = useRef(null);

  const [isMutedMainVideo, setIsMutedMainVideo] = useState(true);
  const [mainVideo, setMainVideo] = useState(undefined);
  const [isMainVideo, setIsMainVideo] = useState(true);
  const [isMainVideoLoaded, setIsMainVideoLoaded] = useState(false);
  const { width: windowWidth } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(windowWidth < 768);
  const [isVideoVisible, setIsVideoVisible] = useState(true);
  const [isEpisodesVisible, setIsEpisodesVisible] = useState(isMainVideo);
  const [isUserClickedEpiBtn, setIsUserClickedEpiBtn] = useState<boolean>(false);
  const [isUserClickedPlay, setIsUserClickedPlay] = useState<boolean>(false);
  const [isContentVisible, setIsContentVisible] = useState(true);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const contextValue = useMemo(
    () => ({
      videoRef,
      isMutedMainVideo,
      setIsMutedMainVideo,
      mainVideo,
      setMainVideo,
      isMainVideo,
      setIsMainVideo,
      isMainVideoLoaded,
      setIsMainVideoLoaded,
      isMobile,
      setIsMobile,
      isVideoVisible,
      setIsVideoVisible,
      isEpisodesVisible,
      setIsEpisodesVisible,
      isUserClickedEpiBtn,
      setIsUserClickedEpiBtn,
      isUserClickedPlay,
      setIsUserClickedPlay,
      isContentVisible,
      setIsContentVisible,
      isFullScreen,
      setIsFullScreen,
    }),
    [
      isMutedMainVideo,
      mainVideo,
      isMainVideo,
      isMainVideoLoaded,
      isMobile,
      isVideoVisible,
      isEpisodesVisible,
      isUserClickedEpiBtn,
      isUserClickedPlay,
      isContentVisible,
      isFullScreen,
      videoRef?.current,
    ]
  );

  return <VideoContext.Provider value={contextValue}>{children}</VideoContext.Provider>;
};

// Custom hook for consuming the context
export const useVideoContext = () => {
  return useContext(VideoContext);
};
